@if (loading) {
  <div>
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>
}
<!-- mat-elevation-z8 width-100 center mt-3 -->
<h2 class="center mt-4 mb-4 checkout-header">Order Review</h2>
@if (!loading) {
  <div>
    <mat-card style="overflow: hidden; border-radius: 4px;" class="center">
      <table mat-table [dataSource]="orderList">
        <ng-container matColumnDef="Description">
          <th class="checkout-text" mat-header-cell *matHeaderCellDef>Description</th>
          <td mat-cell *matCellDef="let element">
            {{ element.servicePlan.description }}
            @if (element.isOutOfStock && element.quantityAvailable > 0) {
              <h1 class="quantity-message">
                Please Change Quantity, Only {{ element.quantityAvailable }} Available
              </h1>
            }
            @if (element.isOutOfStock && element.quantityAvailable == 0) {
              <h1 class="quantity-message">
                Please Remove, Service Out of Stock
              </h1>
            }
          </td>
        </ng-container>
        <ng-container matColumnDef="Rate">
          <th mat-header-cell *matHeaderCellDef>Rate</th>
          <td mat-cell *matCellDef="let element">
            ${{ element.servicePlan.rate.toFixed(2) }}
          </td>
        </ng-container>
        <ng-container matColumnDef="Appointment Location">
          <th mat-header-cell *matHeaderCellDef>Appointment Location</th>
          <td mat-cell *matCellDef="let element">
            {{ element.appointmentLocation}}
          </td>
        </ng-container>
        <ng-container matColumnDef="Appointment Length">
          <th mat-header-cell *matHeaderCellDef>Appointment Length</th>
          <td mat-cell *matCellDef="let element">
            {{ element.servicePlan.appointmentType }}
          </td>
        </ng-container>
        <ng-container matColumnDef="Quantity Requested">
          <th mat-header-cell *matHeaderCellDef>Quantity Requested</th>
          <td mat-cell *matCellDef="let element">
            <input class="quantity" [class.quantity-warn]="element.isOutOfStock" mat-input min="0" [disabled]="loading" type="number" [ngModelOptions]="{ updateOn: 'blur' }" [ngModel]="element.quantity" (ngModelChange)="onQuantityChange($event, element)" />
          </td>
        </ng-container>
        <ng-container matColumnDef="Total Cost">
          <th mat-header-cell *matHeaderCellDef>Total Cost</th>
          <td mat-cell *matCellDef="let element">
            ${{ element.total.toFixed(2) }}
          </td>
        </ng-container>
        <ng-container matColumnDef="Remove Item">
          <th mat-header-cell *matHeaderCellDef>Remove Item</th>
          <td mat-cell *matCellDef="let element">
            <mat-icon class="clickable red-icon" (click)="removeItem(element)">delete</mat-icon>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" colspan="4">No Services in Cart</td>
        </tr>
      </table>
    </mat-card>
    <div class="center width-100 mt-3">
      <mat-accordion>
        <mat-expansion-panel [expanded]="true" hideToggle>
          <mat-expansion-panel-header>
            <mat-panel-title class="checkout-header">
              Customer Terms and Conditions, Must agree to complete checkout
              <mat-icon>expand_more</mat-icon>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <a [href]="termsLink" target="_blank">View Terms and Conditions</a
            >
            <form class="mt-3" [formGroup]="termsFormGroup">
              <mat-checkbox
                color="primary"
                formControlName="agreedToTermsForm"
                >
                  <div class="mt-2">Agree to Terms and Conditions</div>
                </mat-checkbox
                >
              </form>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
        <div class="checkout-box">
          <div class="checkout-box-components">
            <strong>Total Cost: ${{ currentOrder.total.toFixed(2) }}</strong>
          </div>
          <mat-divider></mat-divider>
          @if (isUserLoggedIn) {
            <div class="mt-2">
              <button
                [disabled]="!isUserLoggedIn || !isCartEmpty || !agreedToTerms"
                (click)="beginStripePayment()"
                color="primary"
                style="border-radius: 4px;"
                mat-flat-button
                >
                Checkout
              </button>
            </div>
          }
          @if (!isUserLoggedIn) {
            <div class="mt-2">
              <button style="width: 165px; padding-left: 12px; border-radius: 4px;" (click)="routeToLogin()" color="primary" mat-flat-button>
                Login to Checkout
              </button>
            </div>
          }
        </div>
      </div>
    }